export {};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', () => this.loadContent(true));
  }

  loadContent(focus = true): void {
    window.pauseAllMedia?.();
    if (this.getAttribute('loaded')) return;

    const template = this.querySelector<HTMLTemplateElement>('template');
    const sourceEl = template?.content.firstElementChild?.cloneNode(true);
    if (!sourceEl) return;

    const content = document.createElement('div');
    content.appendChild(sourceEl);

    this.setAttribute('loaded', 'true');
    const deferredElement = this.appendChild(
      content.querySelector<HTMLElement>('video, model-viewer, iframe')!
    );

    if (focus) deferredElement.focus();

    if (deferredElement.getAttribute('autoplay') === 'autoplay' && 'play' in deferredElement) {
      (deferredElement as HTMLVideoElement).play();
    }
  }

  autoLoadContent(): void {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.loadContent(false);
        observer.disconnect();
      }
    });
    observer.observe(this);
  }

  connectedCallback(): void {
    if (this.dataset.autoLoad) {
      this.autoLoadContent();
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}
